module.exports = __webpack_public_path__ + "img/Q&A.6aa02299.svg";